import { createFileRoute } from '@tanstack/react-router'
import { ResetPasswordForm } from '@/features/auth/reset-password'

/**
 * Route shell. Definition and guards only — the form lives in a feature.
 *
 * The form reads `token` and `email` from the URL search params. The reset
 * link is built in `apps/api/app/Modules/Identity/Notifications/PlatformAdminPasswordResetNotification.php`
 * and points at `${frontend_admin_url}/reset-password?token=…&email=…` —
 * the SPA picks the values up from the search params. Missing or empty
 * params are a 422 on submit; we still gate the form on submit rather than
 * the URL so a user who arrives without them sees a working screen and gets
 * a useful error.
 */
export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordForm,
  validateSearch: (search: Record<string, unknown>): { token?: string; email?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
})
